import {
    buttonActionFunc
} from "./common/_buttonAction";
import {
    headerFunc
} from "./common/_header";
import {
    footerFunc
} from "./common/_footer";
import {
    commonFunc
} from "./common/_common";
import {
    modalFunc
} from "./common/_modal";
import {
    fadeInFunc
} from "./common/_fadeIn";
import {
    smoothScrollFunc
} from "./common/_smoothScroll";
import {
    homeFunc
} from "./pages/_home";
import {
    storyFunc
} from "./pages/_story";

// フェードアップは描画前に初期化して「表示→非表示」のチラつきを防ぐ
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fadeInFunc);
} else {
    fadeInFunc();
}

// 全アセット読み込み完了で目隠しを解除（KV等のフェードもこの後に再生）
function markLoaded() {
    document.documentElement.classList.add('is-loaded');
}
// 万一 load が遅い／発火しない場合のフォールバック（最大6秒で解除）
var loadingFallback = window.setTimeout(markLoaded, 6000);

$(window).on('load', function () {
    window.clearTimeout(loadingFallback);
    markLoaded();
    commonFunc();
    headerFunc();
    footerFunc();
    smoothScrollFunc();
    buttonActionFunc();
    modalFunc();
    homeFunc();
    storyFunc();
});